<section class="flex flex-col gap-2">
  <app-segment
    [options]="segmentOptions"
    [(value)]="segment"
    (valueChange)="handleSegmentChange()"
  />
  <router-outlet />
</section>
